export interface Seeker {
    id: number;
    name: string;
    email: string;
    role: string;
    exp: string;
    location: string;
    status: 'Submitted' | 'Pending' | 'Reviewed' | 'Approved' | 'Rejected' | 'Hired';
    phone: string;
}

export interface Recruiter {
    id: number;
    company: string;
    recruiter: string;
    email: string;
    role: string;
    status: 'Submitted' | 'Pending' | 'Reviewed' | 'Approved' | 'Rejected' | 'Blocked';
}

export interface SeekerFormData {
    name: string;
    email: string;
    phone: string;
    role: string;
    exp: string;
    location: string;
    resumeUrl: string;
}

export interface RecruiterFormData {
    company: string;
    recruiter: string;
    email: string;
    role: string;
    skills: string;
    location: string;
}

export interface Notification {
    msg: string;
    type: 'success' | 'pending';
}

export interface ButtonProps {
    children: React.ReactNode;
    onClick?: () => void;
    variant?: 'primary' | 'secondary' | 'danger' | 'outline' | 'text';
    className?: string;
    type?: 'button' | 'submit' | 'reset';
    fullWidth?: boolean;
    theme?: 'light' | 'dark';
    disabled?: boolean;
}

export interface InputProps {
    label: string;
    type?: string;
    placeholder?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    name?: string;
    required?: boolean;
}

export interface SelectProps {
    label: string;
    options: string[];
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    name?: string;
    required?: boolean;
}

export interface BadgeProps {
    status: string;
}

export interface CardProps {
    children: React.ReactNode;
    title?: string;
    className?: string;
    theme?: 'light' | 'dark';
}

export interface SeekerRegistrationProps {
    onRegister: (data: SeekerFormData) => void;
    navigate: (view: string) => void;
    theme: 'light' | 'dark';
}

export interface SeekerStatusProps {
    seekers: Seeker[];
    navigate: (view: string) => void;
}

export interface RecruiterRegistrationProps {
    onRegister: (data: RecruiterFormData) => void;
    navigate: (view: string) => void;
}

export interface AdminLoginProps {
    onLogin: () => void;
    theme?: 'light' | 'dark';
}

export interface AdminDashboardProps {
    seekers: Seeker[];
    recruiters: Recruiter[];

    seekerPage: number;
    seekerTotalPages: number;
    seekerTotal: number;
    onSeekerPageChange: (page: number) => void;

    recruiterPage: number;
    recruiterTotalPages: number;
    recruiterTotal: number;
    onRecruiterPageChange: (page: number) => void;

    onSeekerFilter: (status: string) => void
    onRecruiterFilter: (status: string) => void

    seekerFilter: string | null
    recruiterFilter: string | null

    updateSeekerStatus: (id: number, status: string) => Promise<void>;
    updateRecruiterStatus: (id: number, status: string) => Promise<void>;
    logout: () => void;
    refreshData: () => void;
    loading: boolean;
}

// Add this to types/index.ts
export interface PublicLayoutProps {
    children: React.ReactNode;
    theme: 'light' | 'dark';
    mobileMenuOpen: boolean;
    setMobileMenuOpen: (open: boolean) => void;
    setView: (view: string) => void;
    toggleTheme: () => void;
    setTheme: (theme: 'light' | 'dark') => void;
}

// Update LandingPageProps to include theme
export interface LandingPageProps {
    // navigate: (view: string) => void;
    theme: 'light' | 'dark';
}

// Add theme to all page component props that need it
export interface SeekerStatusProps {
    seekers: Seeker[];
    navigate: (view: string) => void;
    theme: 'light' | 'dark';
}

export interface SeekerRegistrationProps {
    onRegister: (data: SeekerFormData) => void;
    theme: 'light' | 'dark';
}

export interface RecruiterRegistrationProps {
    onRegister: (data: RecruiterFormData) => void;
    navigate: (view: string) => void;
    theme: 'light' | 'dark';
}

// Add this after the other state declarations
export const jobRoles = [
    { value: '', label: 'Select Job Role' },
    { value: 'Housekeeping', label: 'Housekeeping' },
    { value: 'Security Guard', label: 'Security Guard' },
    { value: 'Plumber', label: 'Plumber' },
    { value: 'Carpenter', label: 'Carpenter' },
    { value: 'Maid', label: 'Maid' },
    { value: 'Supervisor', label: 'Supervisor' },
    { value: 'Painter', label: 'Painter' },
    { value: 'Teacher', label: 'Teacher' },
    { value: 'Accountant', label: 'Accountant' },
    { value: 'Driver', label: 'Driver' },
    { value: 'Telecaller', label: 'Telecaller' },
    { value: 'Electrician', label: 'Electrician' },
    { value: 'Gardener', label: 'Gardener' },
    { value: 'Mason', label: 'Mason' },
    { value: 'Office Staff', label: 'Office Staff' }
];

export const PAGE_LIMIT = 10;
